import { api } from "@/lib/api";

export const providerOffersApi = {
    list: () => api.get("/provider/offers").then((r) => r.data.items),
    create: (payload) => api.post("/provider/offers", payload).then((r) => r.data),
    update: (id, payload) => api.patch(`/provider/offers/${id}`, payload).then((r) => r.data),
    submit: (id) => api.post(`/provider/offers/${id}/submit`).then((r) => r.data),
    remove: (id) => api.delete(`/provider/offers/${id}`).then((r) => r.data),
};

export const adminOffersApi = {
    list: (params = {}) => api.get("/admin/offers", { params }).then((r) => r.data),
    update: (id, payload) => api.patch(`/admin/offers/${id}`, payload).then((r) => r.data),
    remove: (id) => api.delete(`/admin/offers/${id}`).then((r) => r.data),
    decide: (id, payload) => api.post(`/admin/offers/${id}/decide`, payload).then((r) => r.data),
    createForProvider: (providerId, payload) =>
        api.post(`/admin/offers/by-provider/${providerId}`, payload).then((r) => r.data),
};
